<template>
  <base-floating-card>
    <div id="delete-package-card">
      <delete-package-art class="art" />
      <div id="heading-and-buttons">
        <h5 id="delete-package-heading">Delete {{ subject.name }}?</h5>
        <div id="delete-package-buttons">
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'x'"
            @click="close"
          />
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'checkmark'"
            @click="confirm"
          />
        </div>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "@/Components/UI/FloatingCards/BaseFloatingCard.vue";
import RoundButtonWithIcon from "@/Components/UI/RoundButtonWithIcon.vue";
import DeletePackageArt from "@/Components/UI/Illustrations/DeletePackage.vue";
export default {
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
  created() {},
  components: {
    BaseFloatingCard,
    RoundButtonWithIcon,
    DeletePackageArt,
  },
  emits: ["close", "confirm"],
  props: ["subject", "processing"],
};
</script>
<style scoped>
#delete-package-card {
  display: flex;
  justify-content: space-between;
  padding: 50px;
}

.art {
  height: 75px;
  margin-right: 70px;
}

#heading-and-buttons {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#delete-package-buttons {
  display: flex;
  width: 100px;
  justify-content: space-between;
}
</style>
